import { render, staticRenderFns } from "./Header2.vue?vue&type=template&id=eef6afa0&scoped=true"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"
import style0 from "./Header2.vue?vue&type=style&index=0&id=eef6afa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef6afa0",
  null
  
)

export default component.exports